import * as yup from "yup";

const schema = yup.object().shape({
  code: yup.string()
  // .required("Coupon code is required"),  
});

export default schema;
